module.exports = __webpack_public_path__ + "img/called.9f73c991.svg";